import { render, staticRenderFns } from "./protocol-dialog.vue?vue&type=template&id=4fd81705"
import script from "./protocol-dialog.vue?vue&type=script&lang=js"
export * from "./protocol-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports